module.exports = __webpack_public_path__ + "assets/img/plant-2.488a2d3c.png";